import React, { Suspense } from 'react';
import LandingPage from './LandingPage';

// A/B test ('landing_v2') disabled — always render LandingPage. VariantB is kept
// on disk (unused) in case the experiment is revisited later.
export default function LandingPageEntry() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <LandingPage />
    </Suspense>
  );
}
